import EnterpriseZone from '../../../components/customer/enterprises/enterprise/EnterpriseZone'

const CustomerEnterprise = () => {
    return <EnterpriseZone />
}

export default CustomerEnterprise
